export default [
  {
    id: 1,
    name: "Agriculture and Veterinary Medicine",
    subjects: [
      { id: 1, name: "Agriculture" },
      { id: 2, name: "Farm Management" },
      {
        id: 3,
        name: "Horticulture"
      },
      { id: 4, name: "Plant and Crop Sciences" },
      { id: 5, name: "Veterinary Medicine" },
      {
        id: 6,
        name: "Other Agriculture and Veterinary Medicine Courses"
      }
    ]
  },
  {
    id: 2,
    name: "Applied and Pure Science",
    subjects: [
      { id: 7, name: "Astronomy" },
      { id: 8, name: "Biology" },
      {
        id: 9,
        name: "Biomedical Sciences"
      },
      { id: 10, name: "Chemistry" },
      { id: 11, name: "Earth Sciences" },
      {
        id: 12,
        name: "Environmental Sciences"
      },
      { id: 13, name: "Food Science and Technology" },
      { id: 14, name: "General Sciences" },
      {
        id: 15,
        name: "Life Sciences"
      },
      { id: 16, name: "Materials Sciences" },
      { id: 17, name: "Mathematics" },
      {
        id: 18,
        name: "Physical Geography"
      },
      { id: 19, name: "Physics" },
      { id: 20, name: "Sports Science" },
      {
        id: 21,
        name: "Other Applied and Pure Science Courses"
      }
    ]
  },
  {
    id: 3,
    name: "Architecture and Construction",
    subjects: [
      { id: 22, name: "Architecture" },
      { id: 23, name: "Built Environment" },
      {
        id: 24,
        name: "Construction"
      },
      { id: 25, name: "Maintenance Services" },
      { id: 26, name: "Planning" },
      {
        id: 27,
        name: "Property Management"
      },
      { id: 28, name: "Surveying" },
      { id: 29, name: "Other Architecture and Construction Courses" }
    ]
  },
  {
    id: 4,
    name: "Business and Management",
    subjects: [
      { id: 30, name: "Accounting" },
      { id: 31, name: "Business Studies" },
      {
        id: 32,
        name: "E-Commerce"
      },
      { id: 33, name: "Entrepreneurship" },
      { id: 34, name: "Finance" },
      {
        id: 35,
        name: "Human Resource Management"
      },
      { id: 36, name: "Management" },
      { id: 37, name: "Marketing" },
      { id: 38, name: "MBA" },
      {
        id: 39,
        name: "Office Administration"
      },
      { id: 40, name: "Quality Management" },
      { id: 41, name: "Retail" },
      {
        id: 42,
        name: "Transportation and Logistics"
      },
      { id: 43, name: "Other Business and Management Courses" }
    ]
  },
  {
    id: 5,
    name: "Computer Science and IT",
    subjects: [
      { id: 44, name: "Computer Science" },
      { id: 45, name: "Computing" },
      {
        id: 46,
        name: "Computer Information Systems"
      },
      { id: 47, name: "IT" },
      { id: 48, name: "Multimedia" },
      { id: 49, name: "Software" },
      {
        id: 50,
        name: "Other Computer Science and IT Courses"
      }
    ]
  },
  {
    id: 6,
    name: "Creative Arts and Design",
    subjects: [
      { id: 51, name: "Art" },
      { id: 52, name: "Art Administration" },
      {
        id: 53,
        name: "Crafts"
      },
      { id: 54, name: "Dance" },
      { id: 55, name: "Fashion and Textile Design" },
      {
        id: 56,
        name: "Graphic Design"
      },
      { id: 57, name: "Industrial Design" },
      { id: 58, name: "Interior Design" },
      {
        id: 59,
        name: "Music"
      },
      { id: 60, name: "Non - industrial Design" },
      { id: 61, name: "Theatre and Drama Studies" },
      {
        id: 62,
        name: "Other Creative Arts and Design Courses"
      }
    ]
  },
  {
    id: 7,
    name: "Education and Training",
    subjects: [
      { id: 63, name: "Adult Education" },
      { id: 64, name: "CPD" },
      {
        id: 65,
        name: "Career Advice"
      },
      { id: 66, name: "Childhood Education" },
      { id: 67, name: "Coaching" },
      {
        id: 68,
        name: "Education Learning"
      },
      { id: 69, name: "Education Management" },
      { id: 70, name: "Education Research" },
      {
        id: 71,
        name: "Educational Psychology"
      },
      { id: 72, name: "Pedagogy" },
      { id: 73, name: "Special Education" },
      {
        id: 74,
        name: "Specialised Teaching"
      },
      { id: 75, name: "Teacher Training PGCE" },
      { id: 76, name: "Other Education and Training Courses" }
    ]
  },
  {
    id: 8,
    name: "Engineering",
    subjects: [
      { id: 77, name: "Aerospace Engineering" },
      { id: 78, name: "Biomedical Engineering" },
      {
        id: 79,
        name: "Chemical and Materials Engineering"
      },
      { id: 80, name: "Civil Engineering" },
      { id: 81, name: "Electrical Engineering" },
      {
        id: 82,
        name: "Electronic Engineering"
      },
      { id: 83, name: "Environmental Engineering" },
      {
        id: 84,
        name: "General Engineering and Technology"
      },
      { id: 85, name: "Manufacturing and Production" },
      { id: 86, name: "Marine Engineering" },
      {
        id: 87,
        name: "Mechanical Engineering"
      },
      { id: 88, name: "Metallurgy" },
      { id: 89, name: "Mining and Oil & Gas Operations" },
      {
        id: 90,
        name: "Power and Energy Engineering"
      },
      { id: 91, name: "Quality Control" },
      { id: 92, name: "Structural Engineering" },
      {
        id: 93,
        name: "Telecommunications"
      },
      { id: 94, name: "Vehicle Engineering" },
      { id: 95, name: "Other Engineering Courses" }
    ]
  },
  {
    id: 9,
    name: "Health and Medicine",
    subjects: [
      { id: 96, name: "Complementary Health" },
      { id: 97, name: "Counselling" },
      {
        id: 98,
        name: "Dentistry"
      },
      { id: 99, name: "Health Studies" },
      { id: 100, name: "Health and Safety" },
      {
        id: 101,
        name: "Medicine"
      },
      { id: 102, name: "Midwifery" },
      { id: 103, name: "Nursing" },
      {
        id: 104,
        name: "Nutrition and Health"
      },
      { id: 105, name: "Ophthalmology" },
      { id: 106, name: "Pharmacology" },
      {
        id: 107,
        name: "Physiology"
      },
      { id: 108, name: "Physiotherapy" },
      { id: 109, name: "Psychology" },
      {
        id: 110,
        name: "Public Health"
      },
      { id: 111, name: "Other Health and Medicine Courses" }
    ]
  },
  {
    id: 10,
    name: "Humanities",
    subjects: [
      { id: 112, name: "Archaeology" },
      { id: 113, name: "Classics" },
      {
        id: 114,
        name: "Cultural Studies"
      },
      { id: 115, name: "English Studies" },
      { id: 116, name: "General Studies" },
      {
        id: 117,
        name: "History"
      },
      { id: 118, name: "Languages" },
      { id: 119, name: "Literature" },
      {
        id: 120,
        name: "Museum Studies"
      },
      { id: 121, name: "Philosophy" },
      { id: 122, name: "Regional Studies" },
      {
        id: 123,
        name: "Religious Studies"
      },
      { id: 124, name: "Other Humanities Courses" }
    ]
  },
  {
    id: 11,
    name: "Law",
    subjects: [
      { id: 125, name: "Civil Law" },
      { id: 126, name: "Criminal Law" },
      {
        id: 127,
        name: "International Law"
      },
      { id: 128, name: "Legal Advice" },
      { id: 129, name: "Legal Studies" },
      {
        id: 130,
        name: "Public Law"
      },
      { id: 131, name: "Other Law Courses" }
    ]
  },
  {
    id: 12,
    name: "Personal Care and Fitness",
    subjects: [
      { id: 132, name: "Aromatherapy" },
      { id: 133, name: "Beauty Therapy" },
      {
        id: 134,
        name: "Hairdressing"
      },
      { id: 135, name: "Health and Fitness" },
      { id: 136, name: "Massage" },
      {
        id: 137,
        name: "Reflexology"
      },
      { id: 138, name: "Therapeutic" },
      { id: 139, name: "Other Personal Care and Fitness Courses" }
    ]
  },
  {
    id: 13,
    name: "Social Studies and Media",
    subjects: [
      { id: 140, name: "Anthropology" },
      { id: 141, name: "Economics" },
      {
        id: 142,
        name: "Environmental Management"
      },
      { id: 143, name: "Film & Television" },
      { id: 144, name: "Human Geography" },
      {
        id: 145,
        name: "International Development"
      },
      { id: 146, name: "International relations" },
      { id: 147, name: "Journalism" },
      {
        id: 148,
        name: "Library Studies"
      },
      { id: 149, name: "Linguistics" },
      { id: 150, name: "Media" },
      { id: 151, name: "Photography" },
      {
        id: 152,
        name: "Politics"
      },
      { id: 153, name: "Public Administration" },
      { id: 154, name: "Social Sciences" },
      {
        id: 155,
        name: "Social Work"
      },
      { id: 156, name: "Sociology" },
      { id: 157, name: "Writing" },
      {
        id: 158,
        name: "Other Social Studies and Media Courses"
      }
    ]
  },
  {
    id: 14,
    name: "Travel and Hospitality",
    subjects: [
      { id: 159, name: "Aviation" },
      { id: 160, name: "Catering" },
      {
        id: 161,
        name: "Food and Drink Production"
      },
      { id: 162, name: "Hospitality" },
      { id: 163, name: "Hotel Management" },
      {
        id: 164,
        name: "Leisure Management"
      },
      { id: 165, name: "Travel and Tourism" },
      { id: 166, name: "Other Travel and Hospitality Courses" }
    ]
  }
];
